import { useApi } from './useApi';
import { apiService } from '../services/api';

interface StrapiImageFormat {
  url: string;
  width: number;
  height: number;
}

interface StrapiImageData {
  id: number;
  url: string;
  alternativeText?: string;
  width: number;
  height: number;
  formats?: {
    thumbnail?: StrapiImageFormat;
    small?: StrapiImageFormat;
    medium?: StrapiImageFormat;
    large?: StrapiImageFormat;
  };
}

interface TeamMemberData {
  id: number;
  documentId: string;
  name: string;
  jobTitle: string;
  image?: StrapiImageData;
  bio?: string;
  order?: number;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

interface TeamSectionData {
  id: number;
  documentId: string;
  title: string;
  subtitle?: string;
  backgroundColor?: string;
  teamMembers: TeamMemberData[];
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export function useTeamSectionStrapi() {
  // Fetch team-section single type from the public API (auto-includes locale)
  return useApi<TeamSectionData>(apiService.getTeamSection);
}

export function useTeamMembers() {
  return useApi<TeamMemberData[]>(apiService.getTeamMembers);
}